import { render, staticRenderFns } from "./82.vue?vue&type=template&id=0ec61ee0&scoped=true&"
var script = {}
import style0 from "./82.vue?vue&type=style&index=0&id=0ec61ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec61ee0",
  null
  
)

export default component.exports